module.exports = __webpack_public_path__ + "static/media/login-hero.196803d9.png";